import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Api } from "../../../../services/api";
import { RoomFormType, YesNo } from "./roomSchema";
import { Office, OfficeRoom } from "../../../../services/api/types/Offices";
import { OfficeStatus } from "../../../../enums";
import { RoomForm, RoomFormHeader } from "../RoomForm";

export const EditRoom = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [office, setOffice] = useState<Office>();
  const [room, setRoom] = useState<RoomFormType>();
  const history = useHistory();
  const { officeId, roomId } =
    useParams<{ officeId: string; roomId: string }>();

  useEffect(() => {
    fetchOffice();
  }, [officeId]);

  const fetchOffice = async () => {
    try {
      const response = await Api.offices.getOffice(officeId);
      response.data.status = OfficeStatus[response.data.status as number];
      setOffice(response.data);
    } catch (e) {
      console.error("Fetch Office Error:", e);
    }
  };

  useEffect(() => {
    fetchRoom();
  }, [roomId]);

  const fetchRoom = async () => {
    try {
      const response = await Api.offices.getOfficeRoom(roomId);
      const data: RoomFormType = {
        roomName: response.data.name,
        roomNumber: response.data.officeNumber,
        computerNumber: response.data.computerNumber,
        computerPassword: response.data.computerPassword,
        computerUserName: response.data.computerUserName,
        hasAppleTv: YesNo[response.data.hasAppleTv ? 0 : 1],
        hasHdmi: YesNo[response.data.hasHdmi ? 0 : 1],
      };
      setRoom(data);
      setIsLoading(false);
    } catch (e) {
      console.error("Fetch Office Error:", e);
    }
  };

  const navigateToEdit = () => {
    const currentLocation = history.location;
    currentLocation.pathname =
      currentLocation.pathname.split("/").slice(0, -2).join("/") + "/edit";
    history.push(currentLocation);
  };

  const submitValues = (values: RoomFormType) => {
    const data: OfficeRoom = {
      id: roomId,
      name: values.roomName || "",
      officeNumber: values.roomNumber || 0,
      computerNumber: values.computerNumber || "",
      computerPassword: values.computerPassword || "",
      computerUserName: values.computerUserName || "",
      hasAppleTv: values.hasAppleTv === "Yes",
      hasHdmi: values.hasHdmi === "Yes",
    };
    try {
      Api.offices.updateOfficeRoom(officeId, roomId, data).then(res => {
        console.info(res);
        navigateToEdit();
      });
    } catch (error) {
      console.error("Update Team Member:", error);
    }
  };

  return (
    <>
      {!isLoading && office && (
        <RoomForm
          header={RoomFormHeader.edit}
          submitValues={submitValues}
          office={office}
          value={room}
        />
      )}
    </>
  );
};
